<!-- event-type.component.html -->
<main>
    <div>
        <div class="eventType-head flex-wrap gap-2">
            <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
                <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
                <div class="header-text eventType-text">
                    Manage focus area
                </div>
            </div>
            <div class="buttonContainer flex-wrap">
                <!-- <div> -->
                    <div class="search-container">
                        <div class="search-icon">
                            <img src="assets/icons/side-bar/search-normal.svg" alt="search"
                                style="width: 18px; height: 18px;" />
                        </div>
                        <input type="text" placeholder="Search here..." class="search-input" [(ngModel)]="search"
                            (input)="updateSearch(search)" (keyup.enter)="applyFilter()" autocomplete="off" />
                    </div>
                <!-- </div> -->
                <button class="generate-btn" *ngIf="userRoles.genarateReport" (click)="navigateReports()">
                    Generate report<img class="action-button" src="assets/images/arrow-up-right.svg" alt="Edit" />
                </button>
                <app-button label="Add new focus area" *ngIf="userRoles.addNew" [minWidth]="'13rem'"
                    (clicked)="openAddDialog()">
                </app-button>
            </div>
        </div>

        <div class="table-card">
            <!-- <div class="d-flex justify-content-end pb-3">
                <button class="filter-button">
                    <img src="assets/images/filter-edit.svg" alt="search" class="filter-icon" />
                </button>
            </div> -->
            <app-table [columns]="columns" [data]="data" [actionTemplate]="actionButtonsTemplate" [loading]="loading"
                actionButtonName="Action" (statusClick)="onStatusClick($event)">
            </app-table>
        </div>
    </div>
</main>

<ng-template #actionButtons let-row *ngIf="userRoles.listItem.edit">
    <div style="display: flex; gap: 0.8rem; justify-content: center;">
        <img *ngIf="userRoles.listItem.edit" class="action-button" (click)="onEdit(row)"
            src="assets/images/Buttons/edit-button.svg" alt="Edit" />
        <img class="action-button" (click)="onDelete(row)" src="assets/images/Buttons/delete-button.svg" alt="Delete" />
    </div>
</ng-template>

<ng-template #addEventTypeContent>
    <add-focus-area [initialData]="editingEventType" (formSubmitted)="onEventTypeFormSubmit($event)">
    </add-focus-area>
</ng-template>